import { HOUR_IN_MILLIS } from 'utils/constants';
import { formatTimeValue } from 'utils/time';

export function formatDuration(durationInMillis: number) {
  const durationFormat =
    durationInMillis < HOUR_IN_MILLIS ? 'mm:ss' : 'H:mm:ss';

  return formatTimeValue(durationInMillis, durationFormat);
}
